import type { Database } from "@/integrations/supabase/types";
import { MIN_INTERESTS } from "@/lib/people-constants";
import { isExpert } from "@/lib/expert";
import { OPT_OUT_STATUS, type OnboardingFacts } from "@/lib/onboarding-steps";

type Row = Database["public"]["Tables"]["profiles"]["Row"];

/** Факты для выбора шагов мастера из строки профиля. */
export function factsFromProfile(p: Row, hasDistrictList: boolean): OnboardingFacts {
  const meetStatus = (p.coffee_status ?? []).filter(Boolean);
  return {
    interests: p.interests ?? [],
    minInterests: MIN_INTERESTS,
    city: p.city,
    profession: p.profession ?? "",
    meetStatus,
    hasContact: !!p.telegram?.trim() || (p.social_links ?? []).some((s) => !!s?.trim()),
    optOut: meetStatus.includes(OPT_OUT_STATUS),
    hasDistrictList,
    tourist: p.visitor_kind === "tourist",
    district: p.district,
    photoUrl: p.photo_url,
    isExpert: isExpert(p),
    savedStep: p.onboarding_step ?? 0,
    about: p.about,
    lookingForTags: p.looking_for_tags ?? [],
    lookingFor: p.looking_for,
  };
}
